import React from "react";
import { Helmet } from "react-helmet-async";
import { Routes, Route } from "react-router-dom";
import ForgotPassword from "../../components/forgotPassword";
import Layout from "../../../Login/components/layout";
import GuestRoute from "../../components/GuestRoute";

const ForgotPasswordContainer = () => (
  <GuestRoute>
    <main>
      <Helmet title="Forgot Password" />
      <Layout>
        <Routes>
          <Route path="/:operationId" element={<ForgotPassword />} />
          <Route path="/" element={<ForgotPassword />} />
        </Routes>
      </Layout>
    </main>
  </GuestRoute>
);

export default ForgotPasswordContainer;
